import MDinput from '@/components/MDinput';
import { validatorRequire } from '@/utils/validators';

export function getFormDefinition(vue) {
  return {
    name: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 32,
        required: true
      },
      rules: [{ validator: validatorRequire }]
    },
    serviceUrl: {
      type: MDinput,
      defaultValue: '',
      props: {
        caption: 'exactInstance.serviceUrl',
        maxlength: 128
      }
    },
    serverName: {
      type: MDinput,
      defaultValue: '',
      props: {
        caption: 'exactInstance.serverName',
        maxlength: 32
      }
    }
  };
}

export default getFormDefinition;

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  const form = {
    ...item
  };
  return form;
}
